import {PageTransformFn} from '../types'

import {Routes} from '@/src/config/routes'

import {PageType} from '@/src/core/domain/entities/page'

export const catalogTransform: PageTransformFn = async (data, session, isMobile) => {
  data.breadcrumbs = data.breadcrumbs.map(breadcrumb => ({
    ...breadcrumb,
    url: (breadcrumb.url && Routes.catalog.section.page(breadcrumb.url, isMobile)) || undefined,
  }))

  if (data.breadcrumbs.length > 0) {
    data.breadcrumbs.unshift({
      title: 'Каталог',
      url: Routes.catalog.page,
    })
  }

  if (data.type == PageType.Certificates) {
    data.breadcrumbs = [
      {
        title: 'Сертификаты',
        url: '',
      },
    ]
  }

  return data
}
